var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-pd vh-100"},[_c('div',{staticClass:"panel panel-1"},[_c('div',{staticClass:"subpanel subpanel-1"},[_vm._v("Experiences")]),_c('div',{staticClass:"subpanel subpanel-2"},[_vm._v("Details")])]),_c('div',{staticClass:"panel panel-2"},[_vm._v(" Map ")])])
}]

export { render, staticRenderFns }